import { EstablishmentsContext } from '@establishment/contexts/establishmentsContext';
import { useContext } from 'react';

const useEstablishments = () => {
  const context = useContext(EstablishmentsContext);
  if (!context) {
    throw new Error(
      'useEstablishments must be used within a EstablishmentsProvider',
    );
  }
  return context;
};

export default useEstablishments;
